import React from 'react';
import { Row } from 'antd';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import _ from 'lodash';
import { Warning } from 'common-components/alerts';

interface AssignWorkerStep8Props {
  conflictErrorMessage: string | null;
  onClose: () => void;
  chooseNewWorker: () => void;
}

export const AssignWorkerStep8 = ({ conflictErrorMessage, onClose, chooseNewWorker }: AssignWorkerStep8Props) => {
  return (
    <>
      <div className='mt-large mb-x2-large'>
        <Warning
          content={conflictErrorMessage ? conflictErrorMessage : 'Oops! Something  went wrong, please try again.'}
        />
      </div>
      <div className={'mt-large'}>
        <Row type={'flex'} justify={'end'}>
          <SecondaryButton className='mr-medium' size='large' onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton size='large' onClick={chooseNewWorker}>
            Choose another worker
          </PrimaryButton>
        </Row>
      </div>
    </>
  );
};
